export interface IDataSetEditor {
    date: string;
    userId: string;
    userName: string;
    userEmail: string;
}

export class DataSetEditor implements IDataSetEditor {
    public date: string;
    public userId: string;
    public userName: string;
    public userEmail: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDataSetEditor);
    constructor(obj?: any) {
        this.date = obj && obj.date || '';
        this.userId = (obj && obj.userId) || (obj && obj.id) || '';
        this.userName = (obj && obj.userName) || (obj && obj.name) || '';
        this.userEmail = (obj && obj.userEmail) || (obj && obj.email) || '';
    }
}
